<template>
    <div>
        <div class="nav-vertical">
			<ul class="nav nav-tabs nav-left" role="tablist">
				<li class="nav-item">
					<a class="nav-link active" v-bind:href="'#t1'+rowData.pessoa_id+''" role="tab" data-toggle="tab" v-if="rowData.pessoa_conexao_ftp.length>0">
						<span class="nav-link-in">
							FTP
							<i class="fa fa-bulding"></i>
						</span>
					</a>
				</li>
                <li class="nav-item">
                    <a class="nav-link" v-bind:href="'#t2'+rowData.pessoa_id+''" role="tab" data-toggle="tab" v-if="rowData.pessoa_conexao_email.length>0">
                        <span class="nav-link-in">
                            Email
                            <i class="fa fa-bulding"></i>
                        </span>
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" v-bind:href="'#t3'+rowData.pessoa_id+''" role="tab" data-toggle="tab" v-if="rowData.pessoa_conexao_api.length>0">
                        <span class="nav-link-in">
                            API
                            <i class="fa fa-bulding"></i>
                        </span>
                    </a>
                </li>
			</ul>

			<div class="tab-content">
				<div role="tabpanel" class="tab-pane fade in active show"  v-bind:id="'t1'+rowData.pessoa_id+''" v-if="rowData.pessoa_conexao_ftp.length>0">
                        <table class="table" id="mais">
                            <thead>
                                <tr>
                                    <th style="width: 10%">Código</th>
                                    <th style="width: 25%">Descrição</th>
                                    <th style="width: 25%">Host</th>
                                    <th style="width: 10%">Porta</th>
                                    <th style="width: 20%">Usuário</th>
                                    <th style="width: 10%">Status</th>
                                </tr>
                             </thead>
                             <tbody>
                                 <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.pessoa_conexao_ftp">
                                    <td>
                                        {{ item.cd }}
                                    </td>
                                    <td>
                                        {{ item.descr }}
                                    </td>
                                    <td>
                                        {{ item.host }}
                                    </td>
                                    <td>
                                        {{ item.porta }}
                                    </td>
                                    <td>
                                        {{ item.usuario }}
                                    </td>
                                    <td>
                                        <span class="badge badge-success" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                                        <span class="badge badge-danger" v-if="item.status.valor==2">{{ item.status.descr }}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                </div><!--.tab-pane-->
                <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey"  v-bind:id="'t2'+rowData.pessoa_id+''" v-if="rowData.pessoa_conexao_email.length>0">
                        <table class="table" id="mais">
                            <thead>
                                <tr>
                                    <th style="width: 10%">Código</th>
                                    <th style="width: 30%">Host</th>
                                    <th style="width: 30%">Usuario</th>
                                    <th style="width: 20%">Tipo Auth</th>
                                    <th style="width: 10%">Status</th>
                                </tr>
                             </thead>
                             <tbody>
                                 <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.pessoa_conexao_email">
                                    <td>
                                        {{ item.cd }}
                                    </td>
                                    <td>
                                        {{ item.host }}
                                    </td>
                                    <td>
                                        {{ item.usuario }}
                                    </td>
                                    <td>
                                        {{ item.tp_auth.descr }}
                                    </td>
                                    <td>
                                        <span class="badge badge-success" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                                        <span class="badge badge-danger" v-if="item.status.valor==2">{{ item.status.descr }}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                </div><!--.tab-pane-->
                <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey"  v-bind:id="'t3'+rowData.pessoa_id+''" v-if="rowData.pessoa_conexao_api.length>0">
                        <table class="table" id="mais">
                            <thead>
                                <tr>
                                    <th style="width: 30%">Código</th>
                                    <th style="width: 40%">Tipo Auth</th>
                                    <th style="width: 30%">Status</th>
                                </tr>
                             </thead>
                             <tbody>
                                 <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.pessoa_conexao_api">
                                    <td>
                                        {{ item.cd }}
                                    </td>
                                    <td>
                                        {{ item.tp_auth.descr }}
                                    </td>
                                    <td>
                                        <span class="badge badge-success" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                                        <span class="badge badge-danger" v-if="item.status.valor==2">{{ item.status.descr }}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                </div><!--.tab-pane-->
			</div><!--.tab-content-->
		</div>
    </div>
  </template>

  <script>
  export default {
      data () {
        return {
          helpForm: new Form({statusRecord: [], params: []}),
        }
    },
    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
    methods: {
  }
}
  </script>
